import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import SearchSortOption from './search_sort_option';

const SearchSort = ({ context, sortables }) => {
  const paramStore = context.getStore('ParamStore');

  const stateFromStores = () => {
    const sortBy = paramStore.get('sort_by');

    return sortBy || 'relevance';
  };

  const [sortingBy, setSortingBy] = useState(stateFromStores());
  const textSize = 'text-sm';

  const onChange = () => {
    setSortingBy(stateFromStores());
  };

  useEffect(() => {
    paramStore.addChangeListener(onChange);
    return () => {
      paramStore.removeChangeListener(onChange);
    };
  }, []);

  const options = () => {
    const opts = [];
    Object.keys(sortables).forEach((sortable) => {
      const title = sortables[sortable];
      opts.push(
        <SearchSortOption
          key={sortable}
          val={sortable}
          active={sortingBy === sortable}
          title={title}
          context={context}
        />
      );
    });

    return opts;
  };

  return (
    <div className="dropdown dropdown-menu-right cursor-pointer">
      <a
        className={`whitespace-nowrap bg-white border-none active:btn:shadow-none ${textSize} font-normal block no-underline text-gray-900`}
        data-toggle="dropdown"
        data-target="#"
      >
        <span className={`mr-2 ${textSize}`}>
          Sort By
          <span className="hidden bs-xs:inline-block">: {sortables[sortingBy]}</span>
        </span>
        <i className="fa-solid fa-caret-down mt-px text-sm" />
      </a>
      <ul className={`dropdown-menu sort-by-menu ${textSize}`} role="menu">
        {options()}
      </ul>
    </div>
  );
};

SearchSort.propTypes = {
  context: PropTypes.object,
  sortables: PropTypes.object
};

export default SearchSort;
